var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/_user-agent.js
 ** module id = 2499
 ** module chunks = 0
 **/